/**
 * Convert date from YYYY-MM-DD format back to YYYYMMDD format for the API
 * @param dateString - The input date string in YYYY-MM-DD format
 * @returns The formatted date string in YYYYMMDD format as required by backend
 */
export const formatDateForAPI = (dateString: string): string => {
  if (!dateString) return '';

  // Convert YYYY-MM-DD to YYYYMMDD format as required by backend
  const formattedDate = dateString.replace(/-/g, ''); // "2022-09-11" -> "20220911"

  return formattedDate;
};
